import React from 'react'
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import usePageTracking from '@/hooks/usePageTracking'
import { useTenant } from '@/contexts/TenantContext'
import { isNavItemVisible } from '@/lib/tenant'
import Layout from './Layout'
import Dashboard from '@/pages/Dashboard'
import DashboardPage from '@/pages/DashboardPage'
import RpiPage from '@/pages/RpiPage'
import ScoresPage from '@/pages/ScoresPage'
import TeamPage from '@/pages/TeamPage'
import SchoolPage from '@/pages/SchoolPage'
import BracketologyIndex from '@/pages/BracketologyIndex'
import BracketologyShow from '@/pages/BracketologyShow'
import BubblePage from '@/pages/BubblePage'
import RecruitingToolkit from '@/pages/RecruitingToolkit'
import NewsPage from '@/pages/NewsPage'
import NewsArticleShow from '@/pages/NewsArticleShow'
import CoachesPollPage from '@/pages/CoachesPollPage'
import TransferPortalPage from '@/pages/TransferPortalPage'
import RecruitingPage from '@/pages/RecruitingPage'
import HighlightsPage from '@/pages/HighlightsPage'

// Redirect a feature route to the dashboard when that feature is hidden for the
// current hub (dead source, or not applicable to the sport), so a direct URL
// can't reach an empty page for a tab we don't show.
function FeatureGate({ label, children }: { label: string; children: React.ReactNode }) {
  const tenant = useTenant()
  const { sport = 'men' } = useParams<{ sport: string }>()
  if (!isNavItemVisible(label, tenant.sportCategory)) {
    return <Navigate to={`/${sport}`} replace />
  }
  return <>{children}</>
}

export default function App() {
  usePageTracking()

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/men" replace />} />
        <Route path="/:sport" element={<Dashboard />} />
        <Route path="/:sport/dashboard" element={<DashboardPage />} />
        <Route path="/:sport/rpi" element={<FeatureGate label="RPI"><RpiPage /></FeatureGate>} />
        <Route path="/:sport/coaches-poll" element={<CoachesPollPage />} />
        <Route path="/:sport/scores" element={<ScoresPage />} />
        <Route path="/:sport/teams/:slug" element={<TeamPage />} />
        <Route path="/:sport/bracketology" element={<FeatureGate label="Bracketology"><BracketologyIndex /></FeatureGate>} />
        <Route path="/:sport/bracketology/:slug" element={<FeatureGate label="Bracketology"><BracketologyShow /></FeatureGate>} />
        <Route path="/:sport/bubble" element={<FeatureGate label="Bubble"><BubblePage /></FeatureGate>} />
        <Route path="/:sport/news" element={<NewsPage />} />
        <Route path="/:sport/news/:slug" element={<NewsArticleShow />} />
        <Route path="/:sport/transfers" element={<FeatureGate label="Transfers"><TransferPortalPage /></FeatureGate>} />
        <Route path="/:sport/recruiting" element={<FeatureGate label="Recruiting"><RecruitingPage /></FeatureGate>} />
        <Route path="/:sport/highlights" element={<HighlightsPage />} />
        <Route path="/schools/:slug" element={<SchoolPage />} />
        <Route path="/recruiting-toolkit" element={<RecruitingToolkit />} />
      </Route>
    </Routes>
  )
}
